import React, { createContext, useContext, useMemo, useState } from "react";

const NewYearAudioContext = createContext({
  isPlaying: false,
  toggleAudio: () => {},
});

export function NewYearAudioProvider({ children }) {
  const [isPlaying, setIsPlaying] = useState(false);
  const value = useMemo(
    () => ({
      isPlaying,
      toggleAudio: () => setIsPlaying((v) => !v),
    }),
    [isPlaying]
  );
  return (
    <NewYearAudioContext.Provider value={value}>
      {children}
    </NewYearAudioContext.Provider>
  );
}

export function useNewYearAudioContext() {
  return useContext(NewYearAudioContext);
}
